/* eslint-disable no-duplicate-case */
import { lazy, Suspense } from "react";
import { SchemaField } from "./types/dataForm/enums";
import { SchemaMeta, SelectOptions } from "./types/dataForm/types";

import InputAutoComplete from "./_partials/InputAutoComplete";
import InputCheckbox from "./_partials/InputCheckbox";
import InputCurrency from "./_partials/InputCurrency";
import InputDatePicker from "./_partials/InputDatePicker";
import InputHidden from "./_partials/InputHidden";
import InputMask from "./_partials/InputMask";
import InputMultipleSelect from "./_partials/InputMultipleSelect";
import InputMultipleAutoComplete from "./_partials/InputMultipleSelectAutocomplete";
import InputPassword from "./_partials/InputPassword";
import InputPhoneNumber from "./_partials/InputPhoneNumber";
import InputSelect from "./_partials/InputSelect";
import InputSwitch from "./_partials/InputSwitch";
import InputTabs from "./_partials/InputTabs";
import InputText from "./_partials/InputText";
/* import InputFile from './_partials/InputFile' */
import InputTimePicker from "./_partials/InputTimePicker";

/**
 * CKEditor tek başına birkaç yüz kilobayt. Sadece texteditor alanı olan
 * formlarda (Categories, Pages) gerektiği için ayrı chunk'a alındı.
 */
const InputTextEditor = lazy(() => import("./_partials/InputTextEditor"));

interface IDataFormInput {
  name?: string;
  meta: SchemaMeta | any;
  mb?: number;
  form: any;
  errors?: Record<string, any>;
  categories?: SelectOptions;
}

export default function DataFormInput({
  name,
  meta,
  form,
  mb,
}: IDataFormInput) {
  const inputName = name || meta.name;
  switch (meta.field) {
    case SchemaField.InputText:
      return (
        <InputText
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      );
    case SchemaField.InputPassword:
      return (
        <InputPassword
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      );
    case SchemaField.InputMask:
      return (
        <InputMask
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      );
    case SchemaField.InputCurrency:
      return (
        <InputCurrency
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      );
    case SchemaField.InputCheckbox:
      return (
        <InputCheckbox
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      );
    case SchemaField.InputSwitch:
      return (
        <InputSwitch
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      );
    case SchemaField.InputSelect:
      return (
        <InputSelect
          key={inputName}
          {...meta}
          name={inputName}
          form={form}
          options={meta?.options}
          mb={mb}
        />
      );
    case SchemaField.InputAutoComplete:
      return (
        <InputAutoComplete
          key={inputName}
          {...meta}
          name={inputName}
          form={form}
          options={meta?.options}
          mb={mb}
        />
      );
    case SchemaField.InputHidden:
      return (
        <InputHidden
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      );
    case SchemaField.InputPhoneNumber:
      return (
        <InputPhoneNumber
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      );
    case SchemaField.InputDate:
      return (
        <InputDatePicker
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      );
    case SchemaField.InputMultipleSelect:
      return (
        <InputMultipleSelect
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      );
    case SchemaField.InputMultipleAutoComplete:
      return (
        <InputMultipleAutoComplete
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      );
    case SchemaField.InputTabs:
      return (
        <InputTabs
          {...meta}
          labelName={meta.labelName}
          schema={meta.schema}
          data={meta.data}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      );
    case SchemaField.InputTextEditor:
      return (
        <Suspense key={inputName} fallback={null}>
          <InputTextEditor
            {...meta}
            name={inputName}
            form={form}
            mb={mb}
          />
        </Suspense>
      );
    /* case SchemaField.InputFile:
      return (
        <InputFile
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      )
    case SchemaField.InputTextEditor:
      return (
        <InputTextEditor
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      )
    case SchemaField.InputTimePicker:
      return (
        <InputTimePicker
          {...meta}
          key={inputName}
          name={inputName}
          form={form}
          mb={mb}
        />
      ) */
    default:
      console.error(`${inputName} is empty`);
      return null;
  }
}
